module.exports = __webpack_public_path__ + "static/media/bg-banner-header-lp-indique-e-ganhe.4726483f.jpg";